import { MARKETPLACE_HIDDEN_PROVIDERS } from '../../../shared/providerSearchBoost.cjs';

const hiddenSlugSet = new Set(MARKETPLACE_HIDDEN_PROVIDERS);

/** Operadores ocultos del marketplace (no deben aparecer en “Más filtros”). */
export function isMarketplaceHiddenProviderSlug(slug) {
  return hiddenSlugSet.has(String(slug || '').toLowerCase().trim());
}

export function excludeHiddenMarketplaceProviders(providerList) {
  if (!providerList?.length) return [];
  return providerList.filter((p) => !hiddenSlugSet.has(p.id));
}

export function stripHiddenMarketplaceProviderIds(ids) {
  if (!ids?.length) return [];
  return ids.filter((id) => !hiddenSlugSet.has(String(id).toLowerCase().trim()));
}
